/**
 * @module Reducers.CoachProfile
 *
 */
import { RequestError } from "typedefs";
import { CoachProfileAction } from "app/actions/scheduling/coachProfile";
import { CoachProfileModel } from "app/models/scheduling/CoachProfileModel";

export type CoachProfileState = {
  data: CoachProfileModel | null;
  error: RequestError | null;
  pending: boolean;
};

const initialState: CoachProfileState = {
  data: null,
  error: null,
  pending: true,
};

export default function listReducer(
  state = initialState,
  action: CoachProfileAction
): CoachProfileState {
  switch (action.type) {
    case "@coachProfile.fetch.pending":
      return { ...state, error: null, pending: true };
    case "@coachProfile.fetch.success":
      return { ...state, data: action.payload, pending: false };
    case "@coachProfile.fetch.error":
      return { ...state, error: action.payload, pending: false };
    case "@coachProfile.clear":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}
